var map = {
	"./decidim/avatar-multiuser.png": 92934,
	"./decidim/brands/facebook.svg": 56144,
	"./decidim/brands/google.svg": 28713,
	"./decidim/brands/twitter-x.svg": 18242,
	"./decidim/cc-badge.png": 23928,
	"./decidim/decidim-logo.svg": 50916,
	"./decidim/default-avatar.svg": 35004,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 10696,
	"./decidim/icons.svg": 65175,
	"./decidim/pattern.png": 57048,
	"./decidim/placeholder-card-g.svg": 87901,
	"./decidim/placeholder-card-l.svg": 1590,
	"./decidim/placeholder.jpg": 46165,
	"./decidim/remixicon.symbol.svg": 10169,
	"./decidim/vendor/social-share-button/douban.svg": 74520,
	"./decidim/vendor/social-share-button/email.svg": 54133,
	"./decidim/vendor/social-share-button/facebook.svg": 73483,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 90533,
	"./decidim/vendor/social-share-button/hacker_news.svg": 61509,
	"./decidim/vendor/social-share-button/linkedin.svg": 35629,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 72862,
	"./decidim/vendor/social-share-button/pinterest.svg": 56075,
	"./decidim/vendor/social-share-button/reddit.svg": 34335,
	"./decidim/vendor/social-share-button/telegram.svg": 83730,
	"./decidim/vendor/social-share-button/tumblr.svg": 91601,
	"./decidim/vendor/social-share-button/twitter.svg": 6852,
	"./decidim/vendor/social-share-button/vkontakte.svg": 94010,
	"./decidim/vendor/social-share-button/wechat.svg": 82437,
	"./decidim/vendor/social-share-button/whatsapp.svg": 90261,
	"./decidim/vendor/social-share-button/x.svg": 39413,
	"./decidim/vendor/social-share-button/xing.svg": 17387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43629;